import toast from 'react-hot-toast';
function toLowerFirstLetter(str) {
  if (!str) return str;
  return str.charAt(0).toLowerCase() + str.slice(1);
}
const formErrorsHandle = (error, values) => {
  if (error?.isLoggingOut || error?.message === 'Logout in progress') {
    return {};
  }
  
  const errors = error?.errors || error?.Errors;
  if (errors) {
    const backendErrorsData = errors.reduce((acc, error) => {
      // Check if the error parameter matches any form field
      if (Object.keys(values).includes(toLowerFirstLetter(error.param))) {
        return {
          ...acc,
          [toLowerFirstLetter(error.param)]: error.message
        };
      } else {
        // Show toast error for non-form field errors
        toast.error(
          error.message || error.Message || 'An unexpected error occurred.'
        );
        return acc;
      }
    }, {});
    return backendErrorsData;
  } else {
    toast.error('An unexpected error occurred. Please try again.');
  }
};
export default formErrorsHandle;
